'use client'

import { MethodBadge } from './MethodBadge'
import { CodeBlock, ExampleBlock } from './CodeBlock'
import { CopyButton } from './CopyButton'
import type { EndpointDoc } from '@/lib/developer-api-docs'
import { getEndpointUrl } from '@/lib/developer-api-docs'

interface EndpointCardProps {
  endpoint: EndpointDoc
}

export function EndpointCard({ endpoint }: EndpointCardProps) {
  const url = getEndpointUrl(endpoint.path.replace('{recipe_id}', 'rec-a1b2c3d4'))

  return (
    <section id={endpoint.id} className='scroll-mt-28 space-y-6 border-b border-black/[0.06] pb-12'>
      <div className='space-y-3'>
        <div className='flex flex-wrap items-center gap-3'>
          <MethodBadge method={endpoint.method} />
          <h2 className='text-display-4 font-bold text-brand-navy'>{endpoint.title}</h2>
        </div>
        <div className='flex items-center gap-2'>
          <code className='font-mono text-sm text-brand-navy'>{url}</code>
          <CopyButton value={url} label='Copy URL' />
        </div>
        <p className='text-sm text-muted-foreground'>{endpoint.description}</p>
        <p className='text-sm text-brand-navy'>
          <span className='font-medium'>Authentication:</span> {endpoint.auth}
        </p>
      </div>

      <ExampleBlock
        label='Request'
        code={endpoint.requestExample}
        language={endpoint.requestExample.trim().startsWith('{') ? 'json' : 'http'}
      />
      <ExampleBlock label='Response' code={endpoint.responseExample} />
      <CodeBlock samples={endpoint.codeSamples} />
    </section>
  )
}
